import React from 'react';

import { connect } from 'react-redux';

import {
    setLanguage,
    setCurrency,
} from '../actions';


const LocaleControl = function(props) {
    let { language, currency, changeLocale } = props;

    let active = (a, b) => a === b ? "active" : "";

    return (
        <div className="controls">
            <div className="control language">
                <span>Sprache:</span>

                <button className={active(language, 'de')} onClick={e => changeLocale('language', 'de')}>DE</button>
                <button className={active(language, 'en')} onClick={e => changeLocale('language', 'en')}>EN</button>
                <button className={active(language, 'fr')} onClick={e => changeLocale('language', 'fr')}>FR</button>
                <button className={active(language, 'nl')} onClick={e => changeLocale('language', 'nl')}>NL</button>
            </div>

            <div className="control currency">
                <span>Währung:</span>

                <button className={active(currency, 'EUR')} onClick={e => changeLocale('currency', 'EUR')}>EUR</button>
                <button className={active(currency, 'USD')} onClick={e => changeLocale('currency', 'USD')}>USD</button>
                <button className={active(currency, 'GBP')} onClick={e => changeLocale('currency', 'GBP')}>GBP</button>
                <button className={active(currency, 'CHF')} onClick={e => changeLocale('currency', 'CHF')}>CHF</button>
            </div>
        </div>
    );
};


const mapStateToProps = (state) => ({
    language: state.locale.language,
    currency: state.locale.currency,
})

const mapDispatchToProps = (dispatch) => ({
    changeLocale: (type, value) => {
        if ( type === "language" ) dispatch(setLanguage(value));
        if ( type === "currency" ) dispatch(setCurrency(value));
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(LocaleControl);



/** WEBPACK FOOTER **
 ** ../ibe/components/LocaleControl.js
 **/